import { OpaccDirectSearchSuggest } from './vendor/script/classes/opacc.class.directsearchsuggest.js';

export class TEDirectSearchSuggest extends OpaccDirectSearchSuggest {
    constructor() {
        super();
    }

    attachEventListener() {
        this.buttonClose = this.htmlDoc.querySelectorAll('.search-toggle-close');
        super.attachEventListener();
    }
}
